import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  GetFullLicenseDetailsAsync,
  IFullLicenceDetails,
} from "../../api/LicenceDetails";

export interface LicenceState {
  fetchStatus: string;
  licence?: IFullLicenceDetails;
}

const initialState: LicenceState = {
  fetchStatus: "Loading...",
  licence: undefined,
};

export const loadFullLicenceDetailsAsync = createAsyncThunk(
  "licence/load",
  async (licenceId: string) => {
    const response = await GetFullLicenseDetailsAsync(licenceId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const licenceSlice = createSlice({
  name: "licence",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadFullLicenceDetailsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadFullLicenceDetailsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licence = action.payload;
      });
  },
});

export const selectLicence = (state: RootState) => state.licence;

export default licenceSlice.reducer;
